import {Loader2} from 'lucide-react'
import {cn} from '@/lib/utils'

type ButtonSpinnerSize = 'xs' | 'sm'

interface ButtonSpinnerProps {
    /** `xs` = h-3 w-3, `sm` = h-4 w-4. Default: `sm`. */
    size?: ButtonSpinnerSize
    /** When true, suppress the default `mr-2` trailing margin (icon-only buttons). */
    noMargin?: boolean
    className?: string
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const sizeClasses: Record<ButtonSpinnerSize, string> = {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
}
/* eslint-enable i18next/no-literal-string */

export function ButtonSpinner({size = 'sm', noMargin, className}: ButtonSpinnerProps) {
    return (
        <Loader2
            data-testid="button-spinner"
            className={cn('animate-spin', sizeClasses[size], !noMargin && 'mr-2', className)}
        />
    )
}
